import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import type { SerieLayerStateItem } from '@/api/generated/schemas';
import { toSerieLayerKey } from '../../internal/serieLayers';
import { SerieStateBadge } from './serieStateBadge';

interface SerieLayerPipelineProps {
  layers: SerieLayerStateItem[];
}

/**
 * Pipeline vrstev seriálu (schválená varianta „chips“) – řádek názvů vrstev se stavovým badge a šipkami mezi nimi.
 */
export function SerieLayerPipeline({ layers }: SerieLayerPipelineProps) {
  const { t } = useTranslation('planner');
  const ordered = [...layers].sort((a, b) => a.sortOrder - b.sortOrder);

  return (
    <div className="border-phx-border mt-[9px] flex flex-wrap items-center gap-x-[7px] gap-y-[5px] border-t pt-[9px]">
      <span className="text-phx-text-muted text-[9px] font-semibold tracking-[0.06em] uppercase">
        {t('serieDetail.layers.label')}
      </span>
      {ordered.map((layer, index) => (
        <Fragment key={layer.layer}>
          {index > 0 ? <span className="text-phx-text-faint text-[11px]">→</span> : null}
          <span className="inline-flex items-center gap-[5px]">
            <b className="text-phx-sm text-phx-text font-semibold">
              {t(`serieDetail.layers.${toSerieLayerKey(layer.layer)}`)}
            </b>
            <SerieStateBadge state={layer.state} />
          </span>
        </Fragment>
      ))}
    </div>
  );
}
